export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const POLL_INTERVAL_MS = 3000;
export const POLL_TIMEOUT_MS = 45_000;
// Backend-confirmed: for the file-upload path specifically, ApproveDisbursement
// no-ops unless status is PENDING_APPROVAL, and the only auto-approve path lives
// in the separate manual-entry endpoint. So APPROVED/PROCESSING/COMPLETED/
// PARTIALLY_PROCESSED/FAILED are unreachable here before a human approves —
// these three are the only terminal statuses this poll will ever see.
export const TERMINAL_BATCH_STATUSES = new Set([
  "PENDING_VALIDATION_ERRORS",
  "PENDING_APPROVAL",
  "FILE_UPLOAD_FAILED",
]);

export const REQUIRED_COLUMNS = [
  {
    label: "Recipient Name",
    desc: "Full name of the recipient",
  },
  {
    label: "Payment Channel",
    desc: 'Must be "Mpesa" or "Bank": One channel per file',
  },
  {
    label: "Amount",
    desc: "Numerical value (e.g., 5000.00). No currency symbols",
  },
  {
    label: "Remarks",
    desc: "Brief description of the payment (max 70 characters)",
  },
];

export const redBannerStyle = {
  root: {
    background: "#fef2f2",
    border: "1px solid #fca5a5",
    borderRadius: "8px",
    padding: "8px 12px",
    "--notification-color": "#ef4444",
  },
};

export const amberBannerStyle = {
  root: {
    background: "#fffbeb",
    border: "1px solid #fcd34d",
    borderRadius: "8px",
    padding: "8px 12px",
    "--notification-color": "#f59e0b",
  },
};

export function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
